import {connect} from 'react-redux';
import ResultEntryComponent from "./ResultEntryComponent";
import {activateBasket, activateFirstTeam, setResult, activateTeam, activateNextTeam} from "../actions";
import {postResult, finishGame} from '../thunkActions';

const getActiveTeam = (state) => {
    const team = state.teams.find(t => t.active);
    return team !== undefined ? team : state.teams[0];
};

const getActiveBasket = (state) => {
    const basket = state.baskets.find(b => b.active);
    return basket !== undefined ? basket : state.baskets[0];
};

const getUniqueTeeCount = (baskets) => {
    // Courses may have baskets with different visible_numbers: f.e. '1A' and '1B'. That's why it is important
    // to merge these baskets into one and get the tee count based on that.
    const basketNumbers = new Set();

    baskets.forEach((basket) => {
        basketNumbers.add(parseInt(basket.visible_number, 10));
    });

    return basketNumbers.size;
};

const getResultsByTeam = (baskets) => {
    const results = {};
    for (let idx = 0; idx < baskets.length; idx += 1) {
        const basket = baskets[idx];

        basket.results.forEach((result) => {
            // If the team doesn't have a result yet, then this score shouldn't be taken into account
            // when calculating the result
            if (result.result === null) {
                // If the team doesn't have a result AND it's the first basket, then the score should
                // be 0
                if (idx === 0) {
                    results[result.team] = 0;
                }
            } else if (idx === 0) {
                results[result.team] = result.result + result.ob;
                results[result.team] -= basket.par;
            } else {
                results[result.team] += result.result + result.ob;
                results[result.team] -= basket.par;
            }
        });
    }
    return results;
};

const mapStateToProps = state => ({
    activeBasket: getActiveBasket(state),
    activeTeam: getActiveTeam(state),
    uniqueTeeCount: getUniqueTeeCount(state.baskets),
    teeCount: state.baskets.length,
    baskets: state.baskets,
    teams: state.teams,
    gameId: state.gameId,
    resultsByTeam: getResultsByTeam(state.baskets),
});

const mapDispatchToProps = dispatch => ({
    navigate(basketId, direction) {
        dispatch(activateBasket(basketId, direction));
        dispatch(activateFirstTeam());
    },
    setScore(basketId, result) {
        dispatch(setResult(basketId, result.team, result.result, result.ob));
        dispatch(postResult(basketId, result.team, result.result, result.ob));
        dispatch(activateNextTeam(result.team));
    },
    setOb(basketId, result) {
        dispatch(setResult(basketId, result.team, result.result, result.ob));
        dispatch(postResult(basketId, result.team, result.result, result.ob));
    },
    activateTeam(teamId) {
        dispatch(activateTeam(teamId));
    },
    finishGame(gameId) {
        dispatch(finishGame(gameId));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultEntryComponent);




// WEBPACK FOOTER //
// ./src/apps/result_entry/components/ResultEntryConnector.js